import { render, staticRenderFns } from "./OccurrenceTypeList.vue?vue&type=template&id=668af8f3"
import script from "./OccurrenceTypeList.vue?vue&type=script&lang=js"
export * from "./OccurrenceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports